// Module
var code = `<div class="datePicker-calendar-component">
    <div class="calendar-component-container">
        <div class="calendar-component">
            <terceraLabel text="{{.labelTextFrom}}" />
            <terceraDatePickerCalendarComponent name="dtPickerFrom" isSetPosition="false" />
        </div>

        <div class="calendar-component">
            <terceraLabel text="{{.labelTextTo}}" />
            <terceraDatePickerCalendarComponent name="dtPickerTo" isSetPosition="false"/>
        </div>
    </div>

    <div class="calendar-component-buttons-container">
        <terceraButton terceraButtonStyle="js-button-blue" text="{{.applyBtnText}}" on-componentClick="applyBtnClick" />
    </div>
</div>`;
// Exports
export default code;